import { TransactionType, } from '../../shared/index.js';
export var isXrplTransaction = function (transaction) { return transaction.type === TransactionType.XRPL; };
//# sourceMappingURL=xrpl.js.map